import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
export function SolutionSection() {
  const {
    ref,
    isVisible
  } = useScrollReveal();
  return <section className="w-full py-24 px-6 relative overflow-hidden" style={{
    background: '#0D1B2A'
  }} data-id="element-238">
      {/* Ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[400px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse, rgba(212,168,83,0.07) 0%, transparent 70%)'
    }} data-id="element-239" />

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-240">
        <div ref={ref} className={`reveal ${isVisible ? 'visible' : ''}`} data-id="element-241">
          <div className="amber-divider mb-8" data-id="element-242" />

          {/* Label */}
          <p className="text-center text-sm uppercase tracking-widest mb-4" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#D4A853'
        }} data-id="element-243">
            La solution
          </p>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-center mb-6" style={{
          fontFamily: 'Playfair Display, serif',
          color: '#F5F0E8'
        }} data-id="element-244">
            La Méthode du{' '}
            <em style={{
            color: '#D4A853'
          }} data-id="element-245">
              "Reset Somatique"
            </em>
          </h2>

          <p className="text-base md:text-lg leading-relaxed text-center mb-12" style={{
          fontFamily: 'DM Sans, sans-serif',
          color: '#C8C0B0'
        }} data-id="element-246">
            Nous ne traitons pas le problème par la pensée (qui est déjà
            saturée), mais{' '}
            <strong style={{
            color: '#F5F0E8'
          }} data-id="element-247">
              par le corps.
            </strong>
          </p>

          {/* Three mechanism cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-12" data-id="element-248">
            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(212,168,83,0.05)',
            border: '1px solid rgba(212,168,83,0.2)'
          }} data-id="element-249">
              <div className="text-3xl mb-3" data-id="element-250">🫀</div>
              <h3 className="text-base font-semibold mb-2" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-251">
                Points de pression
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-252">
                Des points spécifiques qui activent la réponse parasympathique
              </p>
            </div>

            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(212,168,83,0.05)',
            border: '1px solid rgba(212,168,83,0.2)'
          }} data-id="element-253">
              <div className="text-3xl mb-3" data-id="element-254">🌬️</div>
              <h3 className="text-base font-semibold mb-2" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-255">
                Respiration cardiaque
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-256">
                Une fréquence précise pour synchroniser le rythme cardiaque
              </p>
            </div>

            <div className="rounded-xl p-6 text-center" style={{
            background: 'rgba(212,168,83,0.05)',
            border: '1px solid rgba(212,168,83,0.2)'
          }} data-id="element-257">
              <div className="text-3xl mb-3" data-id="element-258">🧠</div>
              <h3 className="text-base font-semibold mb-2" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#F5F0E8'
            }} data-id="element-259">
                Signal "OFF" vagal
              </h3>
              <p className="text-sm leading-relaxed" style={{
              fontFamily: 'DM Sans, sans-serif',
              color: '#8A8070'
            }} data-id="element-260">
                On force le nerf vague à envoyer un signal d'arrêt au cerveau
              </p>
            </div>
          </div>

          {/* Key result */}
          <div className="rounded-2xl p-6 md:p-8 text-center" style={{
          background: 'linear-gradient(135deg, rgba(212,168,83,0.1) 0%, rgba(212,168,83,0.04) 100%)',
          border: '1px solid rgba(212,168,83,0.3)'
        }} data-id="element-261">
            <p className="text-lg md:text-xl leading-relaxed" style={{
            fontFamily: 'Playfair Display, serif',
            color: '#F5F0E8',
            fontStyle: 'italic'
          }} data-id="element-262">
              En moins de{' '}
              <span style={{
              color: '#D4A853',
              fontStyle: 'normal',
              fontWeight: 700
            }} data-id="element-263">
                10 minutes
              </span>
              , vous court-circuitez le pic de cortisol pour plonger dans un
              sommeil réparateur.
            </p>
          </div>
        </div>
      </div>
    </section>;
}